import { isOperationPending } from 'app/operations';

export default id => isOperationPending(`${id}/publish`);
